import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, SelectChangeEvent, Typography } from '@mui/material';

interface FeeTypeSelectsProps {
    feeType: string;
    feeSubType: string;
    feeTypeError?: string;
    feeSubTypeError?: string;
    onFeeTypeChange: (value: string) => void;
    onFeeSubTypeChange: (value: string) => void;
}

export const FeeTypeSelects: React.FC<FeeTypeSelectsProps> = ({
    feeType,
    feeSubType,
    feeTypeError,
    feeSubTypeError,
    onFeeTypeChange,
    onFeeSubTypeChange
}) => {
    return (
        <>
            <FormControl fullWidth size="small" variant="outlined" error={!!feeTypeError}>
                <InputLabel id="fee-type-label">Fee Type *</InputLabel>
                <Select
                    labelId="fee-type-label"
                    id="fee-type-select"
                    value={feeType}
                    onChange={(e: SelectChangeEvent) => onFeeTypeChange(e.target.value)}
                    label="Fee Type *"
                    disabled={true}
                >
                    <MenuItem value="DRG">DRG</MenuItem>
                    <MenuItem value="CPT">CPT</MenuItem>
                </Select>
                {feeTypeError && (
                    <Typography variant="caption" color="error" sx={{ mt: 0.5, ml: 1.75 }}>
                        {feeTypeError}
                    </Typography>
                )}
            </FormControl>

            {feeType === 'CPT' && (
                <FormControl fullWidth size="small" variant="outlined" error={!!feeSubTypeError}>
                    <InputLabel id="fee-sub-type-label">Fee Sub Type *</InputLabel>
                    <Select
                        labelId="fee-sub-type-label"
                        id="fee-sub-type-select"
                        value={feeSubType}
                        onChange={(e: SelectChangeEvent) => onFeeSubTypeChange(e.target.value)}
                        label="Fee Sub Type *"
                    >
                        <MenuItem value="Flat Rate">Flat Rate</MenuItem>
                        <MenuItem value="Grouped">Grouped</MenuItem>
                    </Select>
                    {feeSubTypeError && (
                        <Typography variant="caption" color="error" sx={{ mt: 0.5, ml: 1.75 }}>
                            {feeSubTypeError}
                        </Typography>
                    )}
                </FormControl>
            )}
        </>
    );
};
